export const CDN_BASE_URL = process.env.NEXT_PUBLIC_CDN_URL || 'https://cdn.getlinq.com'
export const S3_CDN_BUCKET = `s3://${process.env.LINQ_BUCKET_CDN || 'getlinq-cdn'}/`
export const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_BASE_URL || 'https://chat.linqalpha.com'

// KR Vercel build sets NEXT_PUBLIC_EARNINGS_DISABLED=true to hide the Earnings Manager
// UI (KR has no stock-server feeding earnings_events). The server gates the actual
// email sends separately via EARNINGS_NOTIFICATIONS_ENABLED — keep the two in sync per region.
export const IS_EARNINGS_MANAGER_DISABLED = process.env.NEXT_PUBLIC_EARNINGS_DISABLED === 'true'

export const TEMP_CONVERSATION_ID = 'temp-conversation-id'
export const RMS_ANALYTICS_FILTERS_KEY = 'rms_analytics_filters'
export const RMS_TEMP_CONVERSATION_ID = 'rms-temp-conversation-id'
export const SEARCH_TEMP_CONVERSATION_ID = 'search-temp-conversation-id'
export const DATA_AGENT_TEMP_CONVERSATION_ID = 'data-agent-temp-conversation-id'
export const CLAUDE_WORKSPACE_TEMP_CONVERSATION_ID = 'claude-workspace-temp-conversation-id'
export const TEMP_MESSAGE_ID = 'temp-message-id'
export const TEMP_INF_ID = 'temp-inference-id'
export const REFERENCE_IDX_REGEX = /\[\s*([\d,\s,\-–]+)\s*\]/g
export const CATALYST_MAX_YEARS = 3 as const
export const GOLDMAN_ORG_NAME = 'Goldman Sachs'
export const AB_ORG_NAME = 'AllianceBernstein'
export const COUNTRY_CODES = [
  { value: '+1', label: '+1 (US/Canada)' },
  { value: '+7', label: '+7 (Russia)' },
  { value: '+31', label: '+31 (Netherlands)' },
  { value: '+33', label: '+33 (France)' },
  { value: '+34', label: '+34 (Spain)' },
  { value: '+39', label: '+39 (Italy)' },
  { value: '+41', label: '+41 (Switzerland)' },
  { value: '+43', label: '+43 (Austria)' },
  { value: '+44', label: '+44 (UK)' },
  { value: '+45', label: '+45 (Denmark)' },
  { value: '+46', label: '+46 (Sweden)' },
  { value: '+47', label: '+47 (Norway)' },
  { value: '+49', label: '+49 (Germany)' },
  { value: '+55', label: '+55 (Brazil)' },
  { value: '+60', label: '+60 (Malaysia)' },
  { value: '+61', label: '+61 (Australia)' },
  { value: '+63', label: '+63 (Philippines)' },
  { value: '+65', label: '+65 (Singapore)' },
  { value: '+66', label: '+66 (Thailand)' },
  { value: '+81', label: '+81 (Japan)' },
  { value: '+82', label: '+82 (South Korea)' },
  { value: '+86', label: '+86 (China)' },
  { value: '+90', label: '+90 (Turkey)' },
  { value: '+91', label: '+91 (India)' },
  { value: '+92', label: '+92 (Pakistan)' },
  { value: '+93', label: '+93 (Afghanistan)' },
  { value: '+94', label: '+94 (Sri Lanka)' },
  { value: '+95', label: '+95 (Myanmar)' },
  { value: '+358', label: '+358 (Finland)' },
  { value: '+673', label: '+673 (Brunei)' },
  { value: '+852', label: '+852 (Hong Kong)' },
  { value: '+853', label: '+853 (Macau)' },
  { value: '+855', label: '+855 (Cambodia)' },
  { value: '+856', label: '+856 (Laos)' },
  { value: '+886', label: '+886 (Taiwan)' },
  { value: '+960', label: '+90 (Maldives)' },
  { value: '+961', label: '+961 (Lebanon)' },
  { value: '+962', label: '+962 (Jordan)' },
]
